import React, {Component} from 'react'
import styled, { css } from 'styled-components'
import { rgba } from 'polished'

import { media } from '../../styles/utils'
import { bgIcon } from '../../styles/global'

class Input extends Component {

    state = {
        focused: false
    }

    onBlur = () => {
        const { toggleFocus } = this.props;

        this.setState({ focused: false })

        if (toggleFocus) {
            toggleFocus(false)
        }
    }

    onFocus = () => {
        const { toggleFocus } = this.props;

        this.setState({ focused: true })

        if (toggleFocus) {
            toggleFocus(true)
        }
    }

    shouldComponentUpdate() {
        // Stop stripe fields from updating

        if (this.props.stripeOptions) {
            return false
        }

        return true
    }
    
    onChangeValue = (e) => {
        const { validator, onChangeValue } = this.props;
        const value = e.target.value;
        
        if (onChangeValue) {
            onChangeValue(value, validator)
        }
    }

    shouldShowError = () => {
        const { focused } = this.state;
        const { shouldValidate, isValid } = this.props;

        if (shouldValidate === true && !isValid) {
            return true
        }

        if (shouldValidate && !isValid && !focused) {
            return true
        }
    }

    getInputProps = () => {
        const { value, label, type, placeholder, className, disabled, name, locale, id, icon} = this.props;
        const showError = this.shouldShowError();

        return {
            className: className,
            id: name,
            type: type,
            placeholder: placeholder || label,
            value: value,
            disabled: disabled,
            hasIcon: icon,
            onChange: !disabled && this.onChangeValue,
            error: showError,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
        }
    }
    

    render() {
        const { focused } = this.state;
        const { errorMessage, helperText, id, icon, type, label, validator, component, name } = this.props;
        const showError = this.shouldShowError();
        const CustomComponent = component || false;
        // console.log(this.props)
        
        return (
            <Wrapper
                id={id}
                className={`${id ? id : ''} dynamic-field`}
            >
                <FieldWrapper
                     className={'field-wrapper'}
                >
                    <Field
                        className={'field'}
                        error={showError}
                    >
                        {!CustomComponent && (
                            <InputWrapper>
                                {type == 'textarea' ? 
                                    <TextField 
                                        {...this.getInputProps()}
                                    />
                                :
                                    <InputField 
                                        {...this.getInputProps()}
                                    />
                                }   
                            </InputWrapper>
                        )}

                        {CustomComponent && (
                            <CustomComponent
                                {...this.props}
                                {...this.props.stripeOptions}
                            />
                        )}
                        
                    </Field>

                    {helperText && (
                        <HelperText>
                            {helperText}
                        </HelperText>
                    )}

                </FieldWrapper>

                {showError && (
                    <Error
                        className={'error'}
                    >
                        {errorMessage}
                    </Error>
                )}

            </Wrapper>
        )
    }
}

export const red = '#FF0000';

export const Wrapper = styled.div`
    width: 100%;
`

const FieldWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    border-bottom: 1px solid #CDCCCA;
    margin-bottom: 15px;
    
`

// Field

export const inputStyle = css`
    appearance: none;
    box-shadow: none;
    display: flex;
    flex: 1;
    height: 52px;
    width: 100%;
    box-sizing: border-box;
    border: 0;
    box-sizing: border-box;
    background: transparent;


    &, &::placeholder {
        font-family: 'Scto';
        font-weight: 300;
        font-size: 18px;
        line-height: 24px;
        color: #595850;

        ${media.phone`
            font-size: 14px;
            line-height: 18px;
        `}
    }

    &::placeholder {
        opacity: 1;
    }

    &:hover {
        /* border: solid 1px orange; */
    }

    &:focus {
        /* border: solid 1px orange;
        box-shadow: 0px 0px 10px -1px ${lightGrey}; */
        outline: none;
    }

    ${props => {
        if (props.disabled) return css`
            pointer-events: none;
            
            &, &::placeholder {
                color: rgba(0, 0, 0, 0.2);
            }
        `
    }}

    ${props => {
        if (props.hasIcon) return css`
            padding-left: 43px;
            padding-bottom: 2px;
        `
    }}
`

const InputWrapper= styled.div``

const Field = styled.div`
    width: 100%;
    select {
        ${inputStyle}
        border-radius: 0;
    }
`

export const InputField = styled.input`
    ${inputStyle}
`

export const TextField = styled.textarea`
    ${inputStyle}
    height: 190px;
    resize: vertical;
    padding-top: 12px;
    box-sizing: border-box;
    ${media.phone`
        height: 160px;
    `}
`

// Label

const Info = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-right: 20px;


    ${media.phone`
        display: none;
    `}
    
`

const Label = styled.div`
    font-size: 16px;
    padding-top: 4px;
    color: white;

    ${props => {
        if (props.error) return css`
            color: ${red}
        `
    }}
`


const message = css`
    font-size: 14px;
`

// Helper Text

export const HelperText = styled.div`
    ${message}
    position: absolute;
    right: -24px;
    max-width: 240px;
    transform: translateX(100%);

    /* ${media.tabletLandscape`
		display: none;
	`} */
`

// Error

export const Error = styled.div`
    ${message}
    color: ${red} !important; 
    margin-top: 8px;
	margin-left: auto;
`

export default Input;


// WEBPACK FOOTER //
// ./src/components/Input/Input.js